import { useState } from "react";
import moment from "moment";

const inicialState = {
    percepcion: "",
    id_provincia: null,
    fecha_vigencia_desde: "",
    coeficiente_unificado: ""
}

export const useCM05Form = () => {
    const [inscrIIBB, setInscrIIBB] = useState([inicialState]);
    const [inscrOriginal, setInscrOriginal] = useState([{}]);
    const [exencionesVigentes, setExencionesVigentes] = useState();
    const [sharedData, setSharedData] = useState();

    const grabarEIniciarIIBB = (data) => {
        setInscrOriginal(structuredClone(data));
        setInscrIIBB(structuredClone(data));
    };

    const iniciarFormulario = (cuit,
    ) => {
        setSharedData({
            cuit,
        })
        setInscrIIBB([
            {
                percepcion: "",
                id_provincia: "",
                coeficiente_unificado: "",
                porcentaje_excencion: "",
                vto_excencion: "",
                impuestoPadron: null,
                modoEdicion: true
            },
        ])
    }

    const addImpuesto = () => {
        const values = [...inscrIIBB];
        values.push({
            percepcion: "",
            id_provincia: "",
            porcentaje_excencion: "",
            vto_excencion: "",
            // fecha_vigencia_desde: sharedData?.fechaDesde,
            // fecha_vigencia_hasta: sharedData?.fechaHasta,
            coeficiente_unificado: "",
            padron: null
        });
        setInscrIIBB(values);
    };

    const removeImpuesto = (index) => {
        const values = [...inscrIIBB];
        values.splice(index, 1);
        if (index === 0 && inscrIIBB.length === 1) {
            setInscrIIBB([
                {
                    percepcion: "",
                    id_provincia: "",
                    // fecha_vigencia_desde: sharedData?.fechaDesde,
                    // fecha_vigencia_hasta: sharedData?.fechaHasta,
                    coeficiente_unificado: "",
                    porcentaje_excencion: "",
                    vto_excencion: "",
                    impuestoPadron: null,
                },
            ]);
        } else {
            setInscrIIBB(values);
        }
    }

    const handleInputChange = (index, event) => {
        const values = [...inscrIIBB];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        setInscrIIBB(values);
    }

    const handleInputChangeDate = (index, e) => {
        const { name, value } = e.target;

        if (name === "vto_excencion" && value) {
            const fechaMinima = moment().startOf('day'); // Hoy
            const fechaIngresada = moment(value);

            // Si la fecha tipeada es anterior a hoy, la forzamos a ser la mínima
            if (fechaIngresada.isBefore(fechaMinima)) {
                // Modificamos el valor antes de guardarlo en el estado
                e.target.value = fechaMinima.format("YYYY-MM-DD");
            }
        }

        // Continuas con tu lógica habitual para actualizar el estado
        const nuevosCampos = [...inscrIIBB];
        nuevosCampos[index][name] = e.target.value;
        setInscrIIBB(nuevosCampos);
    };

    const handleInputChangeProvincia = (index, event, provincias, iibbPadrones) => {
        const values = [...inscrIIBB];
        const idProvinciaSel = event.target.value;
        const dataProvincia = provincias.find(provincia => provincia.id === idProvinciaSel);
        // const exencionVigente = exencionesVigentes?.find(ex=>ex.id_provincia==idProvinciaSel);

        if (dataProvincia?.iibb_auto) {
            values[index]["percepcion"] = iibbPadrones.find(padron => padron.id_provincia === idProvinciaSel)?.percepcion || null;
        } else {
            values[index]["percepcion"] = dataProvincia.percepcion || 0;
        }

        values[index]["id_provincia"] = event.target.value;
        values[index]["impuestoPadron"] = dataProvincia?.iibb_auto;
        values[index]["deshabilitaPercepcion"] = dataProvincia?.percepcion_fija == 1 || dataProvincia?.iibb_auto == 1;
        // console.log(dataProvincia)

        setInscrIIBB(values);
    }

    const armarPayload = () => {
        if (!sharedData.cuit) { alert("No se encuentra el cuit para guardar las inscripciones."); return; }

        return {
            inscripcionesIIBB:
                inscrIIBB
                    .map((registro) => {
                        return {
                            cuit: String(sharedData.cuit).trim(),
                            cuit_limpio: String(sharedData.cuit).replace(/\D/g, ""),
                            percepcion: registro.percepcion,
                            id_provincia: registro.id_provincia,
                            coeficiente_unificado: registro.coeficiente_unificado,
                        };
                    }) || [],

        };
    }


    return {
        inscrIIBB,
        setInscrIIBB,
        grabarEIniciarIIBB,
        addImpuesto,
        removeImpuesto,
        handleInputChange,
        // setField,
        iniciarFormulario,
        handleInputChangeProvincia,
        setExencionesVigentes,
        armarPayload,
        inscrOriginal,
        handleInputChangeDate
        // exencionesVigentes,
        // habilitarEdicionExencion
    }
}

// const habilitarEdicionExencion = () =>{

// }

//   const handlePadronIIBBExc = (index, event, provincia) => {
//     const values = [...padronIIBB];
//     const updatedValue = event.target.name;
//     values[index][updatedValue] = event.target.value;
//     setPadronIIBB(values);
//   };

//   const removerExcencion = (index) => {
//     const values = [...padronIIBB];
//     values[index].porcentaje_excencion = "";
//     values[index].vto_excencion = "";
//     setPadronIIBB(values);
//   };